// import logo from './logo.svg';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Body from './components/Body';
import Contact from './components/Contact';
import {Outlet} from "react-router-dom";
import UserContext from './components/UserContext';
import { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import appStore from './utils/appStore';

function App() {

  const [userName, setuserName] = useState();

  useEffect(()=>{
    const data = {
      name : "saurabh",
    };
    setuserName(data.name);
  }, []);

  return (
    <Provider store={appStore}>
    <UserContext.Provider value={{loggedInUser: userName, setuserName}} >
      <div >
      <Header/>

      {/* <Body/>
      <Contact/> */}

      <Outlet/>
      <Footer/>
    </div>
    </UserContext.Provider>
    </Provider>
  )
}

export default App;
